import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "./context/AuthContext"; 
import { SocketProvider } from "./context/SocketContext";
import { initAuthDebug } from "./utils/authDebug";
import { BrowserRouter } from "react-router-dom";

// Inicializar debug de autenticação
if (process.env.NODE_ENV === 'development') {
  initAuthDebug();
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <SocketProvider>
          <App />
        </SocketProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();